export default __webpack_public_path__ + "static/media/ico_lecturer_tab2.d7c3be3d.png";